import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import styles from './RecordingIndicator.module.css';

interface RecordingIndicatorProps {
  elapsedSeconds: number;
  onStop: () => void;
  onCancel: () => void;
}

/** mm:ss — таймер записи не превышает MAX_RECORDING_SECONDS. */
function formatElapsed(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

// PARA-132 (AC-2, AC-3, AC-15) — видимое состояние записи + таймер + «Стоп» и
// «Отмена». Состояние объявляется в live-region: запись не должна быть заметна
// только зрячему пользователю.
export function RecordingIndicator({
  elapsedSeconds,
  onStop,
  onCancel,
}: RecordingIndicatorProps): JSX.Element {
  const { t } = useTranslation('voice');

  return (
    <div className={styles.indicator} data-testid="voice-recording-indicator">
      <p className={styles.status} role="status">
        <span className={styles.dot} aria-hidden="true" />
        {t('indicator.recording', { timer: formatElapsed(elapsedSeconds) })}
      </p>
      <div className={styles.actions}>
        <Button variant="soft" onClick={onStop}>
          {t('indicator.stop')}
        </Button>
        <Button variant="ghost" onClick={onCancel}>
          {t('indicator.cancel')}
        </Button>
      </div>
    </div>
  );
}
